import React from "react"

type IconProps = React.SVGProps<SVGSVGElement>

const VenueTypeIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 17.0996 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.0996 6.73633V18H0V6.73633L8.5498 0L17.0996 6.73633ZM1.61523 7.51855V16.3848H5.9375V11.4004C5.9375 10.4824 6.68163 9.73754 7.59961 9.7373H10.4502C11.3683 9.73738 12.1123 10.4823 12.1123 11.4004V16.3848H15.4854V7.51855L8.5498 2.05469L1.61523 7.51855ZM7.59961 11.1621C7.46864 11.1623 7.3623 11.2694 7.3623 11.4004V16.3848H10.6875V11.4004C10.6875 11.2693 10.5813 11.1622 10.4502 11.1621H7.59961Z"
      fill="currentColor"
    />
  </svg>
)

export default VenueTypeIcon
